export default {
  name: "Truster Cloud",
  description:
    "Somos una empresa que nacio con el compromiso de llevar la tuya al proximo nivel, partiendo de la gestion correcta de la data de todas las areas, sea cual sea el modelo de tu empresa",
  tel: "+58 412-3210216",
  whatsappTel: "+58 412-3210216",
  email: "info@trusterconsulting.com",
  shortAddress:
    "Urb. La Lagunita, Edificio Dos Torres, El Hatillo, Caracas, Edo. Miranda, Venezuela. 1083.",
  address:
    "Urb. La Lagunita, Edificio Dos Torres, El Hatillo, Caracas, Edo. Miranda, Venezuela. 1083.",
  location: "https://maps.app.goo.gl/78r5feMVxuDt2EYz6",
  rrss: [
    // {
    // 'name': 'Facebook',
    // 	icon:'$mdiFacebook',
    // 	'url': 'https://www.facebook.com/',
    // },
    {
      name: "Instagram",
      icon: "$mdiInstagram",
      url: "https://www.instagram.com/trusterconsulting?igsh=bWp4ODFwZ2Z6emk1",
    },
    // {
    // 	'name': 'Twitter',
    // 	icon:'$mdiTwitter',
    // 	'url': 'https://www.twitter.com/',
    // },
    {
      name: "Linkedin",
      icon: "$mdiLinkedin",
      url: "https://www.linkedin.com/company/trustercloud",
    },
    // {
    // 	'name': 'Youtube',
    // 	icon:'$mdiYoutube',
    // 	'url': 'https://www.youtube.com/',
    // }
  ],
};
